import { Theme } from './theme.model';
import { ImageAsset } from './image-asset.model';

export class DeviceGroup
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }

    public AccountId: number;
    public Description: string;
    public Id: number;
    public ImageId: number;
    public ImageAsset: ImageAsset;
    public ImageAssetId: number;
    public LocationId: number;
    public Metaphor: string;
    public Name: string;
    public OrdinalPosition: number;
    public WhenImageCreated: Date;
    public WhenImageLastUpdated: Date;

    public Themes:any[];
}
